/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.a-select {
  position: relative;
  border: 1px solid var(--gray-60);
}
.a-select select {
  width: 100%;
  line-height: 1.375;
  padding: 0.4375em 0.375em 0.375em;
  border: 0;
  appearance: none;
  background-color: var(--white);
  border-radius: 0;
  color: var(--black);
}
.a-select select:hover, .a-select select.hover {
  outline: 2px solid var(--pacific);
  outline-offset: 0;
}
.a-select select:active, .a-select select:focus, .a-select select.focus {
  box-shadow: 0 0 0 2px var(--pacific);
  outline: 1px dotted var(--pacific);
  outline-offset: 3px;
}
.a-select select[disabled] {
  color: var(--gray-dark);
  background-color: var(--gray-10);
  cursor: not-allowed;
}
.a-select select[disabled]:hover, .a-select select[disabled].hover, .a-select select[disabled]:focus, .a-select select[disabled].focus {
  outline: none;
}
.a-select select[disabled] option,
.a-select select[disabled] option:disabled,
.a-select select option:disabled {
  color: var(--gray-dark);
}
.a-select::after {
  width: 2.1875em;
  box-sizing: border-box;
  border-left: 1px solid var(--gray-60);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: var(--gray-10);
  background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" class="cf-icon-svg cf-icon-svg--down" viewBox="0 0 17 19"><path d="M8.5 15.313a1.03 1.03 0 0 1-.728-.302l-6.8-6.8a1.03 1.03 0 0 1 1.455-1.456L8.5 12.828l6.073-6.073a1.03 1.03 0 0 1 1.455 1.456l-6.8 6.8a1.03 1.03 0 0 1-.728.302"/></svg>');
  background-size: auto 1.1875em;
  background-repeat: no-repeat;
  background-position: center center;
  content: "";
  pointer-events: none;
}
.a-select--disabled::after {
  background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" fill="rgb(90,93,97)" viewBox="0 0 17 19"><path d="M8.5 15.313a1.03 1.03 0 0 1-.728-.302l-6.8-6.8a1.03 1.03 0 0 1 1.455-1.456L8.5 12.828l6.073-6.073a1.03 1.03 0 0 1 1.455 1.456l-6.8 6.8a1.03 1.03 0 0 1-.728.302"/></svg>');
}